export default __webpack_public_path__ + "static/media/36.eb140560.jpg";